import Vue from "vue";
import Vuex from "vuex";

import languages from "./lang.module";
import { common } from "./common.module";
import { crud } from "./crud.module";
import { alert } from "./alert.module";
import { auth } from "./auth.module";
import { wblCategory } from "./wbl-category.module";
import { menu } from "./menu.module";
import { queryBuilderModule } from "./query-builder.module";
import { role } from "./role.module";
import { dashboardWidget } from "./dashboard-widget.module";
import { collectionTable } from "./collectionTable.module";
import { collectionColumn } from "./collectionColumn.module";
import { datetimeSetting } from "./datetime-setting.module";
import { dashboardWidgetItem } from "./dashboard-widget-item.module";
import { procedureWh } from "./procedureWh.module";
import { fixedAssets } from "./fixedAssets.module";

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    languages,
    common,
    crud,
    alert,
    auth,
    wblCategory,
    collectionTable,
    collectionColumn,
    menu,
    role,
    dashboardWidget,
    queryBuilderModule,
    datetimeSetting,
    dashboardWidgetItem,
    procedureWh,
    fixedAssets
  }
});
